/**
 * 点击button打开tryOn的模块，一般适用于产品item, 如专题页、首页的产品列表的tryOn
 */

import { FmDrawer} from "@/ui-component";
import React, { memo } from "react";
import classnames from "classnames";
import { usePageInfoContext } from "@/src/provider";
import DetailsViews from "@/src/components/SpecialSubProductsListB/components/ViewDetails/components/Details"    

const ViewDetails: React.FC = () => {
    const [openViewDetails,DetailsID, closeViewDetails] = usePageInfoContext((state) =>  [state.openViewDetails, state.DetailsID, state.closeViewDetails,state]);
    return (
        <FmDrawer
            open={openViewDetails}
            onClose={closeViewDetails}
            closeable={true}
            anchor={"bottom"}
            // fullHeight
            closeablePosition={"right"}
            childrenClassName={"try-on-content"}
            headerClassName={classnames(
                "try-on-close-icon",
            )}
            boxStyle={{
                backgroundColor:'#f2f2f2',
            }}
            drawerStyle={{
                maxHeight:'14rem'
            }}
        >
            {DetailsID && <DetailsViews key={DetailsID} products_id={DetailsID} />}
        </FmDrawer>
    );
};

export default memo(ViewDetails);
